module.exports = __webpack_public_path__ + "img/sleeve opening.cadef44e.png";